import { UserManager, WebStorageStateStore } from 'oidc-client-ts';
import { logger } from '../utils/logger';
import eventBus from './globalEventBus';

const notifySignedOut = () => {
  eventBus.publish('UserSignedOut');
};

const getClientId = () => {
  const origin = typeof window.getOrigin === 'function' ? window.getOrigin() : 'GRID';
  switch (origin) {
    case 'GRID':
      return '5E04CBD4-1664-4FDA-B00A-4EBA1425456A';
    case 'CENTRIKID':
      return 'F557D26C-0B9A-11EA-8D71-362B9E155667';
    case 'FUGE':
      return '0B98ECDD-7EF1-4FBA-ABB3-0077E7706511';
    case 'STUDENTLIFE':
      return '1F7ED1F6-3F74-4035-991C-902467BEB1F0';
    default:
      return 'B4963680-11AD-47C9-AAB7-8D7F12252363';
  }
};

const getUserManagerSettings = () => ({
  userStore: new WebStorageStateStore({ store: window.localStorage }),
  authority: window.getAccountUrl(),
  client_id: getClientId(),
  redirect_uri: `${window.location.origin}/#/oauth2/callback`,
  response_type: 'code',
  scope: 'openid email profile',
  post_logout_redirect_uri: `${window.location.origin}/#/login`,
  silent_redirect_uri: `${window.location.origin}/silent.html`,
  silentRequestTimeoutInSeconds: 30000,
  accessTokenExpiringNotificationTimeInSeconds: 60,
  automaticSilentRenew: true,
  filterProtocolClaims: true,
  loadUserInfo: true,
  monitorAnonymousSession: true,
  stopCheckSessionOnError: false,
  stateStore: new WebStorageStateStore({ store: window.localStorage }),
});

const setupUserManagerEvents = userManager => {
  userManager.events.addUserLoaded(user => {
    if (user) {
      logger.debug('OIDC User Loaded Access_token: ', user.access_token);
    }
  });

  userManager.events.addUserUnloaded(() => {
    logger.debug('OIDC User Unloaded');
    notifySignedOut();
  });

  userManager.events.addUserSignedOut(() => {
    logger.debug('OIDC User Signed Out');
    notifySignedOut();
  });

  userManager.events.addUserSignedIn(() => {
    userManager
      .signinSilent()
      .then(user => {
        if (user) {
          logger.debug('Silent sign-in after cross-tab sign-in complete');
        }
      })
      .catch(err => logger.error('Silent sign-in failed', err));
  });

  userManager.events.addAccessTokenExpired(() => {
    logger.debug('AccessToken Expired');
    userManager
      .signinSilent()
      .then(user => {
        if (!user) return Promise.reject('Re-authentication required');
        return user;
      })
      .catch(notifySignedOut);
  });

  userManager.events.addSilentRenewError(error => {
    logger.error('Silent Renew Error', error);
  });
};

export const createUserManager = () => {
  const userManager = new UserManager(getUserManagerSettings());
  setupUserManagerEvents(userManager);
  return userManager;
};

let userManager = null;

export const getUserManager = () => {
  if (!userManager) {
    if (window.userManager) {
      userManager = window.userManager;
    } else {
      userManager = createUserManager();
      // Ensure we store the instance globally to prevent multiple instances
      window.userManager = userManager;
    }
  }
  return userManager;
};

window.getUserManager = getUserManager;
